import React from 'react';
import PropTypes from 'prop-types';
import { NoInvoicesFoundCard } from '../components';
import { INVOICE_WQ_BULK_ACTIONS, OPEN_NL_STATUSES, OPEN_PAYER_STATUSES } from '../constants';
import { InvoiceWorkqueue } from './InvoiceWorkqueue';

const OpenInvoices = ({ children }) => (
  <InvoiceWorkqueue
    cboBulkActions={INVOICE_WQ_BULK_ACTIONS.open.cbo}
    defaultBulkActions={INVOICE_WQ_BULK_ACTIONS.default}
    networkLeadBulkActions={INVOICE_WQ_BULK_ACTIONS.open.networkLead}
    networkLeadStatuses={OPEN_NL_STATUSES}
    pageName="Open"
    path="open/"
    payerBulkActions={INVOICE_WQ_BULK_ACTIONS.open.payer}
    payerStatuses={OPEN_PAYER_STATUSES}
    renderNoInvoicesFound={({ isFiltered, resetFilters }) => (
      <NoInvoicesFoundCard isFiltered={isFiltered} status="open" resetFilters={resetFilters} />
      )}
    showInvoiceAging
  >
    {children}
  </InvoiceWorkqueue>
  );

OpenInvoices.propTypes = {
  children: PropTypes.node,
};

OpenInvoices.defaultProps = {
  children: undefined,
};

export default OpenInvoices;
